import { PersonalityRole } from "../../../../../types/domain-types";
import { DtoEntry } from "@/types/dto-types";

export function getReflectionEntryData(entry: DtoEntry | undefined) {
  const x = entry?.["S1V"] ?? 0;
  const y = entry?.["S2V"] ?? 0;

  const personalityRole = getPersonalityRole(x, y);
  const activeQuadrantIndex = getQuadrantFromRole(personalityRole);

  return {
    personalityRole,
    activeQuadrantIndex,
    points: [{ x, y }],
  };
}

export function getPersonalityRole(x: number, y: number): PersonalityRole {
  if (x < 1 / 3) {
    if (y >= 2 / 3) return PersonalityRole.Mediator;
    if (y >= 1 / 3) return PersonalityRole.Controller;
    return PersonalityRole.Brakeman;
  } else if (x < 2 / 3) {
    if (y >= 2 / 3) return PersonalityRole.Advisor;
    if (y >= 1 / 3) return PersonalityRole.Director;
    return PersonalityRole.Critic;
  } else {
    if (y >= 2 / 3) return PersonalityRole.Innovator;
    if (y >= 1 / 3) return PersonalityRole.Motivator;
    return PersonalityRole.Driver;
  }
}

export function getQuadrantFromRole(role: PersonalityRole): number {
  switch (role) {
    case PersonalityRole.Mediator:
      return 0; // Top-left
    case PersonalityRole.Advisor:
      return 1; // Top-center
    case PersonalityRole.Innovator:
      return 2; // Top-right

    case PersonalityRole.Controller:
      return 3; // Middle-left
    case PersonalityRole.Director:
      return 4; // Middle-center
    case PersonalityRole.Motivator:
      return 5; // Middle-right

    case PersonalityRole.Brakeman:
      return 6; // Bottom-left
    case PersonalityRole.Critic:
      return 7; // Bottom-center
    case PersonalityRole.Driver:
      return 8; // Bottom-right

    default:
      throw new Error(`Unknown role: ${role}`);
  }
}

export function filterEntriesForReflectionPersonalSummary(
  entries: DtoEntry[],
  sessionId?: string
) {
  return entries.filter(
    // strictly match only non-dynamic entries from the current session
    entry =>
      entry.isDynamic === false &&
      entry.module === "reflection" &&
      (!sessionId || entry.sessionId === sessionId)
  );
}
